import * as React from 'react';
import { FunctionComponent } from 'react';

type ButtonVariant = 'default' | 'schoolApp';

interface Props {
  onApplyFilterClick: () => void;
  onClearFilterClick: () => void;
  colSpanNumber: number;
  variant?: ButtonVariant;
}

const variantClasses: Record<ButtonVariant, { apply: string; clear: string }> = {
  default: {
    apply: 'btn btn-primary mr-3',
    clear: 'btn btn-secondary',
  },
  schoolApp: {
    apply: 'btn custom-apply-filter-button mr-3',
    clear: 'btn btn-secondary',
  },
};

export const GridFilterButtons: FunctionComponent<Props> = ({
  onApplyFilterClick,
  onClearFilterClick,
  colSpanNumber,
  variant = 'default',
}) => {
  const { apply, clear } = variantClasses[variant];

  return (
    <>
      <th />
      <th colSpan={colSpanNumber - 1} className="text-left">
        <button className={apply} onClick={onApplyFilterClick}>
          Apply filter
        </button>
        <button className={clear} onClick={onClearFilterClick}>
          Clear filter
        </button>
      </th>
    </>
  );
};

GridFilterButtons.displayName = 'GridFilterButtons';
